$(document).ready(function() {
    $(document).on('variant:change', function(event) {
        const detail = event.detail;
        const CTA = $('#klaviyo-BIS');
        const form = $('#kbis-form');

        if (form.length) {
            const variantInput = form.find('input[name="variant_id"]');
            if (variantInput.length && detail.variant && detail.variant.id) {
                variantInput.val(detail.variant.id);
            }
        }

        if (detail.variant) {
            if (detail.variant.available) {
                CTA.hide();
            } else {
                CTA.show();
            }
        }
    });

    $('.modal-close').on('click', function() {
        closeModal();
    });
    
    $('#klaviyo-BIS').on('click', function() {
        $('#kbis-modalOverlay').addClass('active');
        $('.kbis-modal').addClass('active');
    });

    $('#kbis-form').on('submit', function(event) {
        event.preventDefault(); 
        
        const formData = new FormData(this);
        const email = formData.get('email'); 
        const variantId = formData.get('variant_id'); 

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            displayErrorMessage('Please enter a valid email address.');
            return; 
        }

        const options = {
            method: 'POST',
            headers: {
                accept: 'application/json',
                revision: '2024-07-15',
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                data: {
                    "type": "back-in-stock-subscription",
                    "attributes": {
                        "profile": {
                            "data": {
                                "type": "profile",
                                "attributes": {
                                    "email": email, 
                                }
                            }
                        },
                        "channels": ["EMAIL"],
                    },
                    "relationships": {
                        "variant": {
                            "data": {
                                "type": "catalog-variant",
                                "id": `$shopify:::$default:::${variantId}`
                            }
                        }
                    }
                }
            })
        };

        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=X6BHeP', options)
            .then(response => {
                if (response.ok) {
                    hideFormAndShowSuccess('Your subscription has been successfully created.');
                    setTimeout(() => {
                        closeModal(); 
                    }, 2000);
                } else {
                    return response.json().then(err => { 
                        throw new Error(err.message || 'An error occurred while processing your request.');
                    });
                }
            })
            .catch(err => {
                console.error(err);
                displayErrorMessage(err.message || 'An unexpected error occurred. Please try again.');
            });
    });

    function displayErrorMessage(message) {
        let errorContainer = $('#error-message');
        if (!errorContainer.length) {
            errorContainer = $('<div>', { id: 'error-message', style: 'color: red; margin-top: 10px;' });
            $('.kbis-modal .content').append(errorContainer);
        }
        errorContainer.text(message);
    }
    
    function hideFormAndShowSuccess(message) {
        const form = $('#kbis-form');
        form.hide();
        let successContainer = $('#success-message');
        if (!successContainer.length) {
            successContainer = $('<div>', {
                id: 'success-message',
                style: 'color: green; margin-top: 10px; text-align: center;'
            });
            $('.kbis-modal .content').append(successContainer);
        }
        successContainer.text(message).show();
    }

    function closeModal() {
        const form = $('#kbis-form');
        form[0].reset();
        form.show();
        form.find('input[name="email"]').attr('required', '');
    
        $('#success-message').hide();
        $('#kbis-modalOverlay').removeClass('active');
        $('.kbis-modal').removeClass('active');
    }
});
